/**
 * AWS Bedrock Logo SVG Component
 *
 * AWS Bedrock brand logo - rock/foundation inspired
 */

interface AWSBedrockLogoProps {
  className?: string;
}

export function AWSBedrockLogo({ className }: AWSBedrockLogoProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* AWS orange smile/arrow */}
      <path
        d="M6 20C6 20 10 24 16 24C22 24 26 20 26 20"
        stroke="#FF9900"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      {/* Bedrock layers */}
      <path
        d="M8 16L16 8L24 16L16 18L8 16Z"
        fill="url(#bedrock-gradient-1)"
      />
      <path
        d="M8 16L16 18L24 16L16 22L8 16Z"
        fill="url(#bedrock-gradient-2)"
      />
      {/* AI sparkle */}
      <path
        d="M16 11L16.5 13L18 13.5L16.5 14L16 16L15.5 14L14 13.5L15.5 13L16 11Z"
        fill="#FFFFFF"
      />
      <defs>
        <linearGradient
          id="bedrock-gradient-1"
          x1="16"
          y1="8"
          x2="16"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#232F3E" />
          <stop offset="1" stopColor="#3B4D61" />
        </linearGradient>
        <linearGradient
          id="bedrock-gradient-2"
          x1="16"
          y1="16"
          x2="16"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A252F" />
          <stop offset="1" stopColor="#232F3E" />
        </linearGradient>
      </defs>
    </svg>
  );
}
